import { createTheme } from '@mui/material';
import { jaJP as coreJaJP } from '@mui/material/locale';
import { jaJP } from '@mui/x-date-pickers';

const theme = createTheme(
  {
    palette: {
      secondary: {
        main: '#1A96F0',
      },
      common: {
        white: '#FFFFFF',
        green: '#06923E',
        yellow: '#F3C623',
        red: '#FF0000',
        grey: '#BABABA',
        purple: '#9112BC',
        black: '#000000',
      },
    },
    typography: {
      fontFamily: 'Meiryo, Hiragino, sans-serif',
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: '#db3131',
            '&$error': {
              color: '#db3131',
            },
          },
        },
      },
    },
  },
  jaJP,
  coreJaJP
);

export default theme;
